export default __webpack_public_path__ + "static/media/Failure_button.png.0ac0df07.svg";